module.exports = __webpack_public_path__ + "img/max-cloud-edit.174bb98f.svg";